<template lang="pug">
div
    v-dialog(v-model="isShowModal_" @close="isShowModal_=false" width="500")
        v-card
            v-card-title(class="elevation-1") 
                | Actualizar {{nameModulo}} 
                v-spacer
                v-btn(icon @click="isShowModal_=false")   
                    v-icon mdi-close
            v-container( fluid)
                v-row
                    v-col( cols="12" sm="12" md="12")
                        v-autocomplete(v-model="parameter.IdUser" 
                                        :items="InfoUser"
                                        item-text="NameUser"
                                        item-value="IdUser"
                                        label="Usuario"
                                        placeholder="Selecionar Usuario"
                                        outlined
                                        hide-details="auto" 
                                        disabled)    
                v-row
                    v-col( cols="12" sm="12" md="12")
                        v-autocomplete(v-model="parameter.IdDocType" 
                                        :items="InfoDocument"
                                        item-text="Name"
                                        item-value="IdDocType"
                                        label="Documento"
                                        placeholder="Selecionar Documento"
                                        outlined
                                        hide-details="auto" 
                                        disabled) 
                v-row
                    v-col( cols="12" sm="12" md="12")
                        v-autocomplete(v-model="parameter.IdDocCategory" 
                                        :items="InfoCategory.filter(b => b.IdDocType==parameter.IdDocType)"
                                        item-text="NameCategory"
                                        item-value="IdDocCategory"
                                        label="Categoria"
                                        placeholder="Selecionar Usuario"
                                        outlined
                                        hide-details="auto"
                                        disabled) 
                v-row
                    v-col( cols="12" sm="12" md="12")
                        v-autocomplete(v-model="parameter.IdFrequency" 
                                        :items="InfoFrecuncy"
                                        item-text="NameFrequency"
                                        item-value="IdFrequency"
                                        label="Frecuencia"
                                        placeholder="Selecionar Frecuencia"
                                        outlined
                                        hide-details="auto"
                                        disabled) 
                v-row
                    v-col( cols="12" sm="12" md="12")
                        v-autocomplete(v-model="parameter.Period" 
                                        :items="InfoPeriod"
                                        item-text="YEARS"
                                        item-value="YEARS"
                                        label="Periodo"
                                        placeholder="Selecionar Periodo"
                                        outlined
                                        hide-details="auto"
                                        disabled) 
                v-row
                    v-col( cols="12" sm="12" md="12")
                        v-text-field(v-model="parameter.Quantity" label="Meta(Cantidad)")
                v-row 
                    v-col( cols="12" sm="12" md="12")
                        label Activar
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.Active==2 ||  parameter.Active==null ||  parameter.Active==''", @click="parameter.Active=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.Active==1" ,@click="parameter.Active=2" )   ON
            v-divider
            v-card-actions 
                v-spacer                    
                v-btn(color="primary" text @click="sendInfo()") Guardar
</template>
<script>
import modal from "../../../complementos/modal.vue" 
export default {
    props:{ 
        nameModulo:String,
        InfoUser:Array,
        InfoDocument:Array,
        InfoCategory:Array,
        InfoFrecuncy:Array,
        InfoPeriod:Array,
        IsShowModal:Boolean,
        parameter:Object
    },  
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } 
    },
    methods:{ 
            sendInfo(){
                if(this.validate()){
                    this.$emit("update:parameter",this.parameter)
                    this.$emit("sendInfo",this.parameter)
                }       
            },
            validate(){ 
                if(this.parameter.IdEnterprise=='0' || this.parameter.IdEnterprise=='' || this.parameter.IdEnterprise==null ){
                    this.$msgbox.show("No Hay Empresa Selecionada o Cargada","Alerta")
                    return false
                } 
                else if(this.parameter.IdUser=='' || this.parameter.IdUser==null ){
                    this.$msgbox.show("Selecione Usuario","Alerta")
                    return false
                } 
                else if(this.parameter.IdDocType=='' || this.parameter.IdDocType==null ){
                    this.$msgbox.show("Selecione Documento","Alerta")
                    return false
                }
                else if(this.parameter.IdDocCategory=='' || this.parameter.IdDocCategory==null ){
                    this.$msgbox.show("Selecione Categoria","Alerta")
                    return false
                }
                else if(this.parameter.IdFrequency=='' || this.parameter.IdFrequency==null ){
                    this.$msgbox.show("Selecione Frecuencia","Alerta")
                    return false
                }
                else if(this.parameter.Period=='' || this.parameter.Period==null ){
                    this.$msgbox.show("Selecione Periodo","Alerta")
                    return false
                }
                else if(this.parameter.Quantity=='' || this.parameter.Quantity==null ){
                    this.$msgbox.show("Selecione Cantidad a Cumplir","Alerta")
                    return false
                }
                else if(this.parameter.Active=='' || this.parameter.Active==null ){
                    this.$msgbox.show("Selecione si activa respuesta no conformidades","Alerta")
                    return false
                }
                else{
                    return true
                }
            }
    }

    
}
</script>